'use client';

import Link from 'next/link';

type NavLinkItemProps = {
  href: string;
  label: string;
  active?: boolean;
};

export default function NavLinkItem({
  href,
  label,
  active = false,
}: NavLinkItemProps) {
  return (
    <Link
      href={href}
      aria-current={active ? 'page' : undefined}
      style={{
        color: active ? '#ffffff' : '#ebe6e6',
        textDecoration: 'none',
        fontWeight: active ? 700 : 400,
        fontSize: 12,
        lineHeight: 1,
        padding: '0.5rem 1rem',
        borderRadius: 4,
        transition: 'all 0.2s',
        background: active ? '#ebe6e611' : 'transparent',
      }}
    >
      {label}
    </Link>
  );
}